import { client } from "../../../../Infrastructure/agent";

export const accountService = {
  getAllNewRequests: () => client.get("/account/getAllNewRequests"),
  approveRejectRequest: (data) => {
    return client.post("/account/approveorrejectrequest", {
      ...data,
    });
  },
  getAllUsers: () => {
    return client.get("/users/getallusers");
  },
  searchVendors: (terms) => {
    return client.getqs("/users/getallvendors", `searchterm=${terms}`);
  },
  createOrUpdateUser: (user, action) => {
    return client.post("/users/createorupdateuser", { user, action });
  },
  toggleAccess: (acess, id) => {
    return client.post("/users/toggleaccess", { acess, id });
  },
  deleteUser: (id) => {
    return client.post("/users/deleteuser", { id });
  },
  searchUser: (criteria) => {
    return client.post("/users/SearchUser", { criteria });
  },
};

